import { fetch as fetchAPI } from '@lingoking-node-apps/api'
import { useRequestStateStore } from '@/stores/request-state'

export const fetch = (
  url: string,
  options?: null | {
    method?: string
    data?: any
    ignoreSwitchUser?: boolean
    responseType?: string
  },
  loading: boolean = true
) => {
  const requestState = useRequestStateStore()

  return new Promise<any>((resolve, reject) => {
    if (loading) {
      requestState.loading = true
    }

    requestState.error = null

    fetchAPI(url, options)
      .then((response: any) => {
        requestState.loading = false
        resolve(response)
      })
      .catch((error: null) => {
        requestState.loading = false
        requestState.error = error
        reject(error)
      })
  })
}

export const fetchEntity = (
  url: string,
  options?: { method?: string; data?: string; ignoreSwitchUser?: boolean }
) => {
  const requestState = useRequestStateStore()

  return new Promise<any>((resolve, reject) => {
    requestState.loading = true
    requestState.error = null

    fetchAPI(url, options)
      .then((response: any) => {
        requestState.loading = false
        resolve(response['hydra:member'])
      })
      .catch((error: null) => {
        requestState.loading = false
        requestState.error = error
        reject(error)
      })
  })
}
